import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ApiService } from '../services/api.service';
import { ToastService } from '../services/toast.service';
import { LoadingService } from '../services/loading.service';
import { Vendedor, VendedorRequest } from '../models/vendedor.model';
declare var bootstrap: any;

@Component({
  selector: 'app-vendedor-modal',
  templateUrl: './vendedor-modal.component.html',
  styleUrls: ['./vendedor-modal.component.css'],
})
export class VendedorModalComponent implements OnInit {
  @Output() vendedorGuardado = new EventEmitter<void>();
  @Output() vendedorActualizado = new EventEmitter<void>();
  @Output() vendedorModalCancelado = new EventEmitter<void>();
  vendedor: Vendedor = this.getVendedorVacio();
  modoEditar: boolean = false;
  errores: { [key: string]: string } = {};

  constructor(
    private apiSrv: ApiService,
    private toastSrv: ToastService,
    private loadingSrv: LoadingService
  ) {}

  ngOnInit(): void {}

  getVendedorVacio(): Vendedor {
    return {
      id: null,
      nombre: '',
      apellido: '',
      canalVenta: '',
      activo: true,
    };
  }

  abrirModoCreacionVendedor(): void {
    this.modoEditar = false;
    this.vendedor = this.getVendedorVacio();
    this.errores = {};
    this.mostrarModal();
  }

  abrirModoEdicionVendedor(vendedor: Vendedor): void {
    this.modoEditar = true;
    this.vendedor = { ...vendedor };
    this.errores = {};
    this.mostrarModal();
  }

  mostrarModal(): void {
    const modalElement = document.getElementById('vendedorModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();

      modalElement.addEventListener(
        'hidden.bs.modal',
        () => {
          this.cerrarModalVendedor();
        },
        { once: true }
      );
    }
  }

  cerrarModalVendedor(): void {
    const modalElement = document.getElementById('vendedorModal');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }

    // Emitir evento para que el componente padre sepa que el modal fue cancelado
    this.vendedorModalCancelado.emit();
  }

  guardarVendedor(): void {
    this.loadingSrv.setLoading(true);
    if (this.validarVendedor()) {
      const vendedorRequest: VendedorRequest = {
        id: this.vendedor.id || undefined,
        nombre: this.vendedor.nombre,
        apellido: this.vendedor.apellido,
        canalVenta: this.vendedor.canalVenta,
        activo: this.vendedor.activo,
      };

      if (this.modoEditar) {
        this.actualizarVendedor(vendedorRequest);
      } else {
        this.crearVendedor(vendedorRequest);
      }
    } else {
      this.loadingSrv.setLoading(false);
    }
  }

  crearVendedor(vendedorRequest: VendedorRequest): void {
    this.apiSrv.crearVendedor(vendedorRequest).subscribe({
      next: (response) => {
        if (response.status === 200 || response.status === 201) {
          this.cerrarModalVendedor();

          setTimeout(() => {
            this.vendedor = this.getVendedorVacio();
            this.vendedorGuardado.emit();

            this.toastSrv.mostrarNotificacion(
              'Vendedor creado correctamente',
              'success'
            );
          }, 300);
        }
        this.loadingSrv.setLoading(false);
      },
      error: (error) => {
        this.loadingSrv.setLoading(false);
        this.toastSrv.mostrarNotificacion(
          `Error al crear el vendedor: ${error.error}`,
          'error'
        );
      },
    });
  }

  actualizarVendedor(vendedorRequest: VendedorRequest): void {
    this.apiSrv.actualizarVendedor(vendedorRequest).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.cerrarModalVendedor();

          setTimeout(() => {
            this.vendedor = this.getVendedorVacio();
            this.vendedorActualizado.emit();

            this.toastSrv.mostrarNotificacion(
              'Vendedor actualizado correctamente',
              'success'
            );
          }, 300);
        }
        this.loadingSrv.setLoading(false);
      },
      error: (error) => {
        this.loadingSrv.setLoading(false);
        this.toastSrv.mostrarNotificacion(
          `Error al actualizar el vendedor: ${error.error}`,
          'error'
        );
      },
    });
  }

  validarVendedor(): boolean {
    this.errores = {};

    // Validación de nombre (solo letras y espacios)
    if (!this.vendedor.nombre) {
      this.errores['nombre'] = 'El nombre es requerido';
    } else if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(this.vendedor.nombre)) {
      this.errores['nombre'] = 'El nombre debe contener solo letras';
    }

    // Validación de apellido (solo letras y espacios)
    if (!this.vendedor.apellido) {
      this.errores['apellido'] = 'El apellido es requerido';
    } else if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(this.vendedor.apellido)) {
      this.errores['apellido'] = 'El apellido debe contener solo letras';
    }

    // Validación de canal de venta
    if (!this.vendedor.canalVenta) {
      this.errores['canalVenta'] = 'El canal de venta es requerido';
    }

    return Object.keys(this.errores).length === 0;
  }
}
